goog.provide("shadow.js.shim.module$$mui$material$Table");
goog.provide("module$shadow_js_shim_module$$mui$material$Table");
shadow.js.shim.module$$mui$material$Table = shadow.js.nativeProvides["@mui/material/Table"] = shadow$bridge("@mui/material/Table");
module$shadow_js_shim_module$$mui$material$Table.default = shadow.js.shim.module$$mui$material$Table;
